import { apiUtils, authFetch } from '../utils';

const LOCALES_URL = apiUtils.getApiUrl() + '/locales';

export function getAvailableLocales(): Promise<string[]> {
  return authFetch<{ locales?: string[] }>(`${LOCALES_URL}/locales.list`).then(res =>
    res.locales ? res.locales : []
  );
}
